import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import StateButton from '../game/StateButton';
import gameData, { DEFAULT_BUTTON_CONFIG } from '../gameData';
import SoundAssetKeys from '../SoundAssetKeys';
import { playJingle, stopJingle } from '../SoundManager';
import UIAssetKeys from '../UIAssetKeys';
import AnimationScreen from './AnimationScreen';
import ABCyaLib from '@abcya/abcya_lib';
import FontKeys from '../FontKeys';

export default class IntroScreen extends Phaser.Scene {
  static get KEY() { return 'IntroScreen'; }

  constructor() {
    super({ key: IntroScreen.KEY });
  }

  create() {
    this.backgroundImage = ABCyaPhaser.Images.addImage(0,0, UIAssetKeys._intro_background, this).setOrigin(0);
    this.sun = ABCyaPhaser.Images.addImage(this.scale.width / 2 + 190 - 450, -40 + 450, UIAssetKeys._sun, this);
    this.moon = ABCyaPhaser.Images.addImage(this.scale.width / 2 + 190 - 450, -40 + 450,UIAssetKeys._moon, this).setAlpha(0);

    // sun
    ABCyaPhaser.Tweens.addTween(this.sun, 4500, { x: this.sun.x + 500, y: this.sun.y - 500, loop: -1, loopDelay: 4500 }, Phaser.Math.Easing.Linear);
    ABCyaPhaser.Tweens.addTween(this.sun, 4500, { alpha: 1, loop: -1, loopDelay: 4500, onLoop: () => this.sun.alpha = 0 }, Phaser.Math.Easing.Linear);

    // moon
    // for some reason if we use delay in the tween (to delay the start of the tween), the tween doesn't loop correctly... so instead we do a delayed call to start the tween at the right time
    this.time.delayedCall(4500, () => ABCyaPhaser.Tweens.addTween(this.moon, 4500, { x: this.moon.x + 500, y: this.moon.y - 500, loop: -1, loopDelay: 4500 }, Phaser.Math.Easing.Linear));
    ABCyaPhaser.Tweens.addTween(this.moon, 4500, { alpha: 1, loop: -1, delay: 4500, onLoop: () => this.moon.setAlpha(0) }, Phaser.Math.Easing.Linear);

    ABCyaPhaser.Tweens.addTween(this.backgroundImage, 4500, { alpha: 1, loop: -1, loopDelay: 4500 }, Phaser.Math.Easing.Linear);
    ABCyaPhaser.Tweens.addTween(this.backgroundImage, 4500, { alpha: 0.1, loop: -1, delay: 4500 }, Phaser.Math.Easing.Linear);

    this.title = ABCyaPhaser.Text.addCurvedText(this.scale.width / 2 - 150, -200, 140, 0xf15822, FontKeys._dimboregular, ABCyaPhaser.Localization.instance.getLocalizedString('title'), 2000, this, -90 * Phaser.Math.DEG_TO_RAD,null, null, true);

    const titleWidth = this.title.getBounds().width;
    if (titleWidth > 645) {
      this.title.scale = 645 / titleWidth;
    }

    this.title.y += this.title.radius * this.title.scale;
    ABCyaPhaser.Tweens.addTween(this.title, 1400, { delay: 100, y: 100 + (this.title.radius * this.title.scale) }, Phaser.Math.Easing.Bounce.Out);

    this.subtitle = this.add.container(this.scale.width / 2 - 150, -200);
    const mainSubtitle = ABCyaPhaser.Text.addText(0,0, 62, 0xffffff, FontKeys._cloudy_with_a_chance_of_lovRg, ABCyaPhaser.Localization.instance.getLocalizedString('subtitle'), this.subtitle, true).setStroke('#e24f25', 8)
      .setResolution(1.5);

    if (ABCyaLib.Environment.instance.gameConfig.subtitleKey !== null) {
      mainSubtitle.setFontSize(50);
      const secondSubtitle = ABCyaPhaser.Text.addText(0, 0, 42, 0xffffff, FontKeys._cloudy_with_a_chance_of_lovRg, ABCyaPhaser.Localization.instance.getLocalizedString(ABCyaLib.Environment.instance.gameConfig.subtitleKey), this.subtitle, true).setStroke('#e24f25', 8)
        .setResolution(1.5);
      secondSubtitle.y = mainSubtitle.height / 2 + secondSubtitle.height / 2 - 10;
      const bounds = this.subtitle.getBounds();
      const neededOffset = this.subtitle.y - bounds.centerY;
      // eslint-disable-next-line no-param-reassign
      this.subtitle.iterate(child => child.y += neededOffset);
    }

    const subtitleWidth = this.subtitle.getBounds().width;
    if (subtitleWidth > 645) {
      this.subtitle.scale = 645 / titleWidth;
    }

    ABCyaPhaser.Tweens.addTween(this.subtitle, 1400, { delay: 500, y: this.subtitle.y + 420 }, Phaser.Math.Easing.Bounce.Out);

    this.flame = ABCyaPhaser.Images.addImage(this.scale.width / 2 + 30, this.scale.height / 2 + 220, UIAssetKeys._flames, this).setOrigin(0);
    const objectTweenLoop = (obj) => {
      ABCyaPhaser.Tweens.addTween(obj, 200, { x: obj.x + -3, completeDelay: 200 }, Phaser.Math.Easing.Linear,() => {
        ABCyaPhaser.Tweens.addTween(obj, 200, { x: obj.x + 3, completeDelay: 200 }, Phaser.Math.Easing.Linear,() => {
          objectTweenLoop(obj);
        });
      });
    };
    objectTweenLoop(this.flame);

    ABCyaPhaser.Tweens.addTween(this.flame, 700, { scaleY: 0.85, yoyo: true, loop: -1 }, Phaser.Math.Easing.Linear);

    this.rocket = ABCyaPhaser.Images.addImage(this.scale.width / 2 - 100, this.scale.height / 2 - 450, UIAssetKeys._rocket, this).setOrigin(0);
    objectTweenLoop(this.rocket);

    this.button = ABCyaPhaser.Buttons.addDefaultButton(this.scale.width / 2 - 200, this.scale.height / 2 + 20, UIAssetKeys._play_button, null, SoundAssetKeys._click, this.cleanUp.bind(this), this, { ...DEFAULT_BUTTON_CONFIG }).setScale(0);
    ABCyaPhaser.Tweens.addTween(this.button, 300, { delay: 1500, scale: 1 }, Phaser.Math.Easing.Linear, () => this.loopButton());

    this.turnMusicOn();
  }

  cleanUp () {
    this.tweens.killAll();

    this.scene.start(AnimationScreen.KEY);
  }

  loopButton () {
    ABCyaPhaser.Tweens.addTween(this.button, 800, { scale: 1.1 }, Phaser.Math.Easing.Bounce.Out, () => {
      ABCyaPhaser.Tweens.addTween(this.button, 800, { scale: 1 }, Phaser.Math.Easing.Bounce.Out, () => {
        this.loopButton();
      });
    });
  }

  turnMusicOn () {
    // make toggle button for music
    this.musicButton = new StateButton(this, UIAssetKeys._speaker_on, UIAssetKeys._speaker_off);
    this.musicButton.x = this.scale.width - 70;
    this.musicButton.y = this.scale.height - 50;
    this.add.existing(this.musicButton);
    this.musicButton.doAction1 = this.speakerOff.bind(this);
    this.musicButton.doAction2 = this.speakerOn.bind(this);

    if (gameData.MUSIC_ON === false) {
      this.musicButton.switchStateOff();
    }

    if (gameData.MUSIC_ON === true) {
      stopJingle();

      playJingle(SoundAssetKeys._title_theme);
    }
  }

  speakerOff () {
    gameData.MUSIC_ON = false;
    stopJingle();
  }

  speakerOn () {
    gameData.MUSIC_ON = true;
    playJingle(SoundAssetKeys._title_theme);
  }
}